<template>
  <div>
    <!-- 合并弹窗 -->
    <el-dialog title="合并SKU" :visible.sync="dialogVisible" width="60%" top="4vh" :before-close="dialogBeforeClose">
      <div>
        <div class="block">
          <el-upload ref="upload" :action="action" list-type="picture-card" :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :headers="customHeaders" :file-list="imgList"
            multiple>
            <i class="el-icon-plus" style="color: #0724ef;"></i>
          </el-upload>
        </div>
        <div>
          <label style="font-weight:600" for>请选择一条数据作为合并时的主要信息</label>
          <div class="InforBox">
            <div class="box" v-for="(item, index) in batch_select2" :key="index">
              <el-checkbox v-model="item.checkbox" @change="handleCheck(item)"></el-checkbox>
              <el-form label-width="136px">
                <el-form-item label="商品名称：">
                  <el-input v-model="item.title" :disabled="item.disabled"></el-input>
                </el-form-item>
                <el-form-item label="中文简称：">
                  <el-input v-model="item.abbreviation" :disabled="item.disabled"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row type="flex" align="middle" justify="end" slot="label">
                    <p>商品编号/SKU</p>
                    <el-tooltip placement="top">
                      <div slot="content">
                        添加时方便分辨产品的属性样式等功能，非必填项
                      </div>
                      <i class="el-icon-question" />
                    </el-tooltip>
                    <p>：</p>
                  </el-row>
                  <el-input v-model="item.productCode" :disabled="item.disabled">
                    <template slot="prepend">
                      <p v-if="item.skuPrex">{{ item.skuPrex }}</p>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="SKU别名：" v-if="item.salesType != 2">
                  <div v-for="(key, index) in item.relatedItems" :key="index">
                    <div v-for="(val, index) in key.aliasItems" :key="index">
                      <el-input v-model="val.productCodeAlias" :disabled="item.disabled"></el-input>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="型号尺码：" v-if="item.salesType == 1">
                  <el-input v-model="item.sizeModel"></el-input>
                </el-form-item>
                <el-form-item label="商品分类：">
                  <el-row type="flex" align="middle">
                    <p v-if="item.categoryName">{{ item.categoryName }}</p>
                    <el-button type="text" style="border:none" v-if="item.disabled == false"
                      @click="selectClassification(item)">去设置</el-button>
                  </el-row>
                </el-form-item>
                <el-form-item label="商品状态：" v-if="item.salesType == 1">
                  <el-radio-group v-model="item.status" :disabled="item.disabled">
                    <el-radio :label="1">在售</el-radio>
                    <el-radio :label="2">停售</el-radio>
                    <el-radio :label="3">试卖</el-radio>
                    <el-radio :label="4">部分停售</el-radio>
                    <el-radio :label="5">清仓</el-radio>
                    <el-radio :label="6">部分清仓</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="货源URL：">
                  <div v-for="(key, index) in item.sourceUrl" :key="index">
                    <el-input v-model="key.url" :disabled="item.disabled"></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="库存数量：" v-if="item.salesType == 1">
                  <el-input v-model="item.stockNum" :disabled="item.disabled"></el-input>
                </el-form-item>
                <el-form-item label="商品描述：">
                  <el-input type="textarea" v-model="item.productDescription" :disabled="item.disabled"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                  <el-input type="textarea" v-model="item.remark" :disabled="item.disabled"></el-input>
                </el-form-item>
                <el-form-item label="SKU归属者：">
                  <el-table :data="item.itemsBelonger" style="width: 100%" border>
                    <el-table-column label="SKU归属者" align="center" prop="owner">
                    </el-table-column>
                    <el-table-column label="项目提成比例" prop="percentageCommission" align="center">
                    </el-table-column>
                    <el-table-column label="提成开始时间" prop="startTime" align="center">
                    </el-table-column>
                    <el-table-column label="设置时间" prop="createTime" align="center">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-form>
              <el-table :data="item.relatedItems" style="width: 100%" border v-if="item.salesType == 2">
                <el-table-column width="50" type="selection" align="center"></el-table-column>
                <el-table-column prop="productSkuImages" label="图片" align="center">
                  <template slot-scope="scope">
                    <ul class="checked-img-container" v-if="
                      scope.row.productSkuImages &&
                      scope.row.productSkuImages.length
                    ">
                      <li class="img-box" @click="Selected_pictures(scope.row,scope.$index)" v-for="(item,index) in scope.row.productSkuImages.slice(0,3)" :key="index">
                        <img style="width: 100%" :src="item" alt />
                      </li>
                      <li class="img-box" v-show="scope.row.productSkuImages.length > 3">...</li>
                    </ul>
                  </template>
                </el-table-column>
                <el-table-column prop="productVariantMarker" label="变体标识" align="center">
                </el-table-column>
                <el-table-column v-if="item.relatedItems[0].variantDtos.variantDataJson.color" label="颜色" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.variantDtos.variantDataJson.color }}
                  </template>
                </el-table-column>
                <el-table-column v-if="item.relatedItems[0].variantDtos.variantDataJson.size" label="尺寸" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.variantDtos.variantDataJson.size }}
                  </template>
                </el-table-column>
                <el-table-column v-if="item.relatedItems[0].variantDtos.variantDataJson.sleeve" label="袖长" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.variantDtos.variantDataJson.sleeve }}
                  </template>
                </el-table-column>
                <el-table-column v-if="item.relatedItems[0].variantDtos.variantDataJson.waist" label="腰长" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.variantDtos.variantDataJson.waist }}
                  </template>
                </el-table-column>
                <el-table-column prop="productCode" label="SKU" align="center">
                </el-table-column>
                <el-table-column label="SKU别名" align="center">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.aliasItems" :key="index">
                      <p v-if="item.productCodeAlias">{{ item.productCodeAlias }}</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="productCost" label="成本" align="center">
                </el-table-column>
                <el-table-column prop="stockNum" label="商品库存" align="center">
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <p v-if="scope.row.status == 1" style="color: green">在售</p>
                    <p v-else-if="scope.row.status == 2" style="color: red">停售</p>
                    <p v-else-if="scope.row.status == 3" style="color: #0f59a4;">试卖</p>
                    <p v-else-if="scope.row.status == 4" style="color: orange">部分停售</p>
                    <p v-else-if="scope.row.status == 5">清仓</p>
                    <p v-else>部分清仓</p>
                  </template>
                </el-table-column>
              </el-table>
              <el-table :data="item.relatedItems" style="width: 100%" border
                v-else-if="item.salesType == 3 || item.salesType == 4">
                <el-table-column label="商品图片" align="center">
                  <template slot-scope="scope">
                    <el-image v-if="scope.row.productSkuImages" style="width: 100px; height: 100px"
                      :src="scope.row.productSkuImages[0]" fit="fill" :preview-src-list="scope.row.productSkuImages">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="title" label="商品标题" align="center">
                </el-table-column>
                <el-table-column prop="productCode" label="商品SKU" align="center">
                </el-table-column>
                <el-table-column prop="productCost" label="成本/元" align="center">
                </el-table-column>
                <el-table-column label="数量" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.stockNum" placeholder="" style="width:120px"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 已选图片 -->
    <el-dialog title="已选图片" class="uploaderImgVariant" :visible.sync="isShowVariantImg" width="1000px" append-to-body>
      <div class="image-container">
        <div class="img-box" v-for="item in variantImages" :key="item.uid">
          <img :src="item" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowVariantImg = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="isShowVariantImg = false">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分类列表 -->
    <ClassificationList ref="ClassificationList" @childvalue="childByvalue"></ClassificationList>
  </div>
</template>

<script>
import ClassificationList from './ClassificationList.vue'
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
  name: '',
  components: {
    ClassificationList
  },
  data() {
    return {
      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      dialogVisible: false,
      isShowVariantImg: false, //已选图片
      variantImages: [], //已选图片
      SKUId: '',
      batch_select: [],
      batch_select2: [],
      imgList: [],
      result: false,
      imageData: [],
      classifications: [],
    }
  },
  methods: {
    init(data) {
      this.dialogVisible = true
      this.batch_select2 = data
      var newarr = [];
      for (var i = 0; i < this.batch_select2.length; i++) {
        newarr.push(this.batch_select2[i].id);
      }
      this.batch_select = newarr
      this.batch_select2.forEach(item => {
        this.$set(item, 'checkbox', false)
        this.$set(item, 'disabled', true)
        if (typeof item.productImages === "string") {
          item.productImages = item.productImages.split(',')
          item.productImages.map(key => (
            this.imgList.push({url: key})
          ))
        } else {
          item.productImages.map(key => (
            this.imgList.push({url: key})
          ))
        }
        if (typeof item.sourceUrl === "string") {
          const source = item.sourceUrl.split(',')
          item.sourceUrl = source.map(ele => ({url: ele}))
        }
        item.relatedItems.map(key => {
          if (typeof key.productSkuImages === "string") {
            key.productSkuImages = key.productSkuImages.split(",")
          } else {
            key.productSkuImages = key.productSkuImages
          }
        })
      })
    },
    childByvalue(value) {
      this.batch_select2.forEach(item => {
        if (item.id === this.SKUId) {
          item.categoryName = value.name
          item.categoryId = value.id
        }
      })
    },
    selectClassification(item) {
      this.SKUId = item.id
      this.$refs.ClassificationList.init()
    },
    dialogBeforeClose() {
      this.imgList = []
      this.dialogVisible = false
    },
    handleCheck(val) {
      val.disabled = !val.disabled
      this.result = this.batch_select2.some(item => item.disabled)
      if (!this.result) {
        this.$message.warning('只能选择一条作为主数据')
        val.disabled = true
        val.checkbox = false
      }
    },
    save() {
      let resule = true
      const flags = []
      const arr2 = this.batch_select2.map(item => {
        return item.relatedItems.map(key => {
          return key.productVariantMarker
        })
      })
      arr2.map((item, index) => {
        item.map(key => {
          if (index > 0) {
            flags.push(key)
          }
        })
      })
      let sets1 = new Set(arr2[0]);
      flags.forEach(item => {
        sets1.add(item)
        if (sets1.size > arr2[0].length) {
          resule = false
          return
        }
      })

      if (!this.result) {
        this.$message.warning('请选择一条主数据')
      }
      else if (!resule) {
        this.$message.warning('变体信息不相同，无法合并！')
      }
      else {
        const master = this.batch_select2.find(item => item.checkbox == true)
        if (this.imgList.length === 0) {
          this.$message.warning('请上传商品图片')
          return
        } else if (!master.title) {
          this.$message.warning('请填写商品名称')
          return
        } else if (!master.abbreviation) {
          this.$message.warning('请填写中文简称')
          return
        } else {
          master.productImages = master.productImages.join(',')
          const source = master.sourceUrl.map(
            (item) => item.url
          )
          master.sourceUrl = source.join(',')
          if (master.salesType == 2) {
            master.relatedItems.forEach(item => {
              item.productSkuImages = item.productSkuImages.join(',')
            })
          }
          this.batch_select2.map(item => {
            if (item.checkbox != true) {
              item.relatedItems.map(key => {
                master.relatedItems.map(val => {
                  if (val.productVariantMarker === key.productVariantMarker) {
                    val.aliasItems = val.aliasItems.concat(key.aliasItems)
                  }
                })
              })
            }
          })
          const API = Baseurl + 'shopifyProduct/mergeProduct'
          const paramsData = {
            master,
            mergeProductIds: this.batch_select
          }
          ajaxPost(API, paramsData)
            .then((res) => {
              if (res.data.code === 1) {
                this.$message.success('合并成功')
                this.dialogVisible = false
                this.$emit('fatherMethod');
              } else {
                this.$message.error(res.data.message)
                this.dialogVisible = false
                this.$emit('fatherMethod');
              }
            })
        }
      }
    },
    // 已选图片
    Selected_pictures(item) {
      this.isShowVariantImg = true
      this.variantImages = item.productSkuImages
    },
    handleAvatarSuccess(file) {
      this.imageData.push(file)
      this.imgList.push({url: file.data})
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisibleSee = true
    },
    //删除要上传的图片
    handleRemove(_, fileList) {
      this.imgList = fileList
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  margin-bottom: 20px;
}
.InforBox {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .box {
    padding: 10px;
    width: 47.5%;
    border: 1px solid #eee;
    border-radius: 5px;
    position: relative;
    height: 400px;
    margin-bottom: 20px;
    overflow-y: scroll;
    .el-checkbox {
      position: sticky;
      /deep/ .el-checkbox__inner {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.checked-img-container {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 5px;
  .img-box {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    position: relative;
    margin-right: 10px;
    line-height: 28px;
    img {
      width: 100%;
      height: 100%;
      border: 1px solid #dcdfe6;
    }
    .el-icon-circle-close {
      display: none;
      position: absolute;
      right: -7px;
      top: -7px;
      color: #999;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }
    &:hover .el-icon-circle-close {
      display: block;
    }
  }
}
</style>
